<template>
  <div v-if="product" class="w-full">
    <!-- Product code + name -->
    <div class="flex items-center py-1">
      <svg class="text-orange-700 stroke-current h-5 w-5 mr-2 flex-shrink-0" fill="none" stroke-linecap="round"
           stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
        <path d="M7 7h.01"/>
      </svg>
      <a :href="`/products/${product.product_code}`" target="_blank" rel="noopener noreferrer"
         class="bg-orange-200 text-orange-700 hover:bg-orange-300 rounded-lg py-1 px-2 font-semibold">
        {{ product.product_code }}
      </a>
      <a :href="`/products/${product.product_code}`" target="_blank" rel="noopener noreferrer"
         class="text-blue-800 hover:bg-blue-100 rounded-lg px-2 py-1 font-semibold">
        {{ product.name }}
      </a>
    </div>

    <!-- Product type -->
    <div v-if="product.product_type || product.type" class="flex items-center py-1">
      <svg class="text-orange-700 stroke-current h-5 w-5 mr-2 flex-shrink-0" fill="none" stroke-linecap="round"
           stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
      </svg>
      <p class="rounded-lg px-2 py-1">{{ product.product_type || product.type }}</p>
    </div>

    <!-- Description -->
    <div v-if="product.description" class="flex items-start py-1">
      <svg class="text-orange-700 stroke-current h-5 w-5 mr-2 mt-1 flex-shrink-0" fill="none" stroke-linecap="round"
           stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>
      </svg>
      <p class="rounded-lg px-2 py-1">{{ product.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductInfoCard",
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
};
</script>
